import moment from "moment";

import useAssignedStock from "../Hooks/useAssignedStock";
import Table from "../../../components/Table/Table";
import { Pagination } from "../../../components/pagination/Pagination";
import useReduxStore from "../../../hooks/useReduxStore";
import Modal from "../../../components/Modal";
import TextFields from "../../../components/TextField";
import { Button } from "@mui/material";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";

const AssignedStocked = () => {
  const { data, methods } = useAssignedStock();
  const { selector: user } = useReduxStore("auth");
  const { controller, totalCount, employeeList, uassignModal, formData } = data;
  const {
    handlePagination,
    unAssignStock,
    handleOpenModal,
    handleCloseModal,
    handleChange,
  } = methods;

  const TableHead = [
    { label: "#", id: "" },
    { label: "ProductName", id: "productName" },
    { label: "Assign/Unassign Quantity", id: "assignQuantity" },
    { label: "Assigned By", id: "created" },
    { label: "Date of Assign", id: "Date" },
    { label: "Type", id: "type" },
    { label: "Remarks", id: "remark" },
    { label: "Action", id: "action" },
  ];

  return (
    <div>
      <div className="mt-2">
        <table className="table">
          <Table TableHeadData={TableHead} rowCount={TableHead?.length} />
          <tbody>
            {employeeList?.map((item, index) => {
              return (
                <tr
                  className="text-start rounded-row "
                  style={{
                    borderRadius: "50px",
                    backgroundColor: "#fff",
                  }}
                >
                  <td className="table-link">
                    {controller.rowsPerPage * (controller.page - 1) + index + 1}{" "}
                  </td>
                  <td>{item?.inventory_id?.productName}</td>
                  <td className="">{item?.assignQuantity}</td>
                  <td className="">{item?.createdby_id?.firstName}</td>
                  <td className="">
                    {moment(item?.dateOfAssign).format("YYYY-MM-DD")}
                  </td>
                  <td className="">{item?.type}</td>
                  <td className="">{item?.remarks}</td>
                  <td>
                    {/* {item.type === 'UNASSIGN' || item.type === 'NOTINUSE' || item.isStatusChange === true || user?.userInfo?.permission?.inventory?.edit?.value === false ?     
                    <div>
                      <DoNotDisturbIcon color="error"/>
                    </div> 
                    :   */}
                    <div className="dropdown p-0 align-items-center justify-content-center">
                      <i
                        className="fas fa-ellipsis-v pointer p-2"
                        id="dropdownMenuLink"
                        data-bs-toggle={
                          item.type === "UNASSIGN" ||
                          item.type === "NOTINUSE" ||
                          item.isStatusChange === true ||
                          user?.userInfo?.permission?.inventory?.edit?.value ===
                            false
                            ? ""
                            : "dropdown"
                        }
                        aria-expanded="false"
                        style={{
                          cursor:
                            item.type === "UNASSIGN" ||
                            item.type === "NOTINUSE" ||
                            item.isStatusChange === true ||
                            user?.userInfo?.permission?.inventory?.edit
                              ?.value === false
                              ? "not-allowed"
                              : "pointer",
                        }}
                      />
                      <ul
                        className="dropdown-menu"
                        aria-labelledby={`dropdown-${item._id}`}
                      >
                        <li
                          className="dropdown-item"
                          style={{ cursor: "pointer" }}
                          // onClick={() => unAssignStock(item._id, item.type)}
                          onClick={() =>
                            handleOpenModal(item._id, item.type, item)
                          }
                        >
                          {item.type === "ASSIGN"
                            ? "Unassign Item"
                            : item.type === "USE"
                            ? "Mark Unused"
                            : ""}
                        </li>
                      </ul>
                    </div>
                    {/* } */}
                  </td>
                </tr>
              );
            })}

            <td colSpan={"20"}>
              {totalCount > 10 && (
                <Pagination
                  style={{ backgroundColor: "#fff" }}
                  count={totalCount}
                  controller={controller}
                  setController={handlePagination}
                />
              )}
            </td>
          </tbody>
        </table>
        {!employeeList?.length && (
          <div className="text-center">No record found</div>
        )}
      </div>

      <Modal
        size="md"
        show={uassignModal}
        onHide={handleCloseModal}
        headerContent={<h5>Unassign</h5>}
        bodyContent={
          <div className="">
            <div className="row">
              <div className="pt-2">
                <TextFields
                  Lable="Quantity"
                  Name="quantity"
                  type="number"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChange}
                  Value={formData.quantity}
                  width={100}
                />
              </div>
              <div className="pt-2">
                <TextFields
                  Lable="Remark"
                  Name="remarks"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChange}
                  Value={formData.remarks}
                  width={100}
                />
              </div>
            </div>

            <div className="d-flex justify-content-end mt-4">
              <Button variant="outlined" onClick={handleCloseModal}>
                cancel
              </Button>
              <Button
                onClick={unAssignStock}
                variant="contained"
                className="ms-2"
                data-bs-dismiss="modal"
              >
                Confirm
              </Button>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default AssignedStocked;
